import { useEffect, useState } from 'react';
import { usePromptToolboxContext } from '@Context/prompt-toolbox/PromptToolboxContext';
import { useUtilityContext } from '@Context/prompt-toolbox/UtilityContext';

interface ExpandContentProps {
  modalSelected: string;
}

const ExpandedView: React.FC<ExpandContentProps> = ({ modalSelected }) => {
  const { setModal, newPromptData } = useUtilityContext();
  const [contentToExpand, setContentToExpand] = useState<string>('');
  const { selectedPromptVersion } = usePromptToolboxContext();

  // ! For improved modularity, below code can simply be edited by adding modal's title and what content should be displayed
  useEffect(() => {
    if (!modalSelected) return;
    try {
      const contentMap: Record<string, string> = {
        expandVersionPrompt:
          selectedPromptVersion?.version?.prompt || '(No prompt available)',
        expandGPTResult:
          selectedPromptVersion?.version?.gpt_result ||
          '(No AI result available)',
        expandNewVersionPrompt:
          newPromptData.prompt || '(No new version prompt available)',
        expandNewGPTResult:
          newPromptData.response || '(No new AI result available)',
        expandAddNewPromptGPTResult:
          newPromptData.response || '(No new AI result available)',
      };

      setContentToExpand(contentMap[modalSelected] || 'Content not found');
    } catch (error) {
      console.error('Error setting content to expand:', error);
      setContentToExpand('Failed retrieving contents!');
    }
  }, [modalSelected, selectedPromptVersion, newPromptData]);
  return (
    <div>
      <span className="flex flex-col gap-y-10">
        {(selectedPromptVersion ||
          modalSelected === 'expandAddNewPromptGPTResult') && (
          <label className="max-w-lg whitespace-pre-wrap text-lg">
            {/* {selectedPromptVersion.version.prompt ??
              'Failed retrieving contents!'} */}
            {contentToExpand}
          </label>
        )}
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button
            onClick={() => setModal(modalSelected, false)}
            className="rounded-md border border-gray-400 bg-gray-300 px-4 py-2"
          >
            Close
          </button>
        </span>
      </span>
    </div>
  );
};

export default ExpandedView;
